import React from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { SaveOrUpdate } from "../../../../redux/actions/catalogFinancialAction";
import { connect } from "react-redux";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      naam: this.props.history.location.state.rowData.naam,
      code: this.props.history.location.state.rowData.code,
      omschrijving: this.props.location.state.rowData.omschrijving,
      isActive: this.props.history.location.state.rowData.isActive,
      type: this.props.history.location.state.rowData.type,
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleSave() {
    $("#cover-spin").show(0);
    const { actions } = this.props;

    var model = {
      content: {
        algemeen: {
          [this.state.type === "Grootboeknummer" ? "nummer" : "code"]: this
            .state.code,
          actief: this.state.isActive,
          naam: this.state.naam,
          omschrijving: this.state.omschrijving
        },
      },
      identification: this.rowId,
    };

    actions
      .SaveOrUpdate(
        model,
        "PATCH",
        this.rowId,
        window.$catalog_management_units_token
      )
      .then(() => {
        CallBackFunctions.BeheereenheidEditCallBack(
          window.$catalog_management_units_token
        );
        this.props.history.push("/catalog/financial");
      })
      .catch((error) => {
        console.log(error);
      });

    // omnimap
    //   .SaveOrEditAction(
    //     model,
    //     "PATCH",
    //     this.rowId,
    //     window.$catalog_management_units_token
    //   )
    //   .then((result) => {
    //     CallBackFunctions.BeheereenheidEditCallBack(
    //       window.$catalog_management_units_token
    //     );
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async componentDidMount() {
    $("#budget-rows-delete-modal").click(function () {
      window.$catalog_area_selectedIds.forEach((element) =>
        omnimap
          .Delete(element, window.$catalog_management_units_token)
          .then((result) => {
            $("#cover-spin").show(0);

            CallBackFunctions.RowsDeletedCallBack(
              window.$catalog_management_units_token
            );
          })
          .catch((error) => {
            console.log(error);
          })
      );
    });
  }

  render() {
    return (
      <div id="editSide">
        <div className="detail-title">Budget in Edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/financial");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Financial
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit_beheereenheid"
              className="button ok"
              onClick={this.handleSave}
            >
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a
              className="button back"
              onClick={() => {
                this.props.history.push(
                  "/catalog/financial/detail/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam</div>
              <div className="box-title-2-active">
                <input
                  autocomplete="off"
                  value={this.state.naam}
                  name="code"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  value={this.state.code}
                  name="code"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2">
                <input
                  autocomplete="off"
                  value={this.state.omschrijving}
                  name="omschrijving"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  type="checkbox"
                  name="isActive"
                  onChange={this.handleInputChange}
                  checked={this.state.isActive ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        <input hidden id="budget-identification" />
      </div>
    );
  }
}

// export default Edit;
Edit.propTypes = {
  SaveOrUpdate: PropTypes.func.isRequired,
};
function mapStateToProps(state, ownProps) {
  return {
    catalogManagementUnits: state.rowData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      SaveOrUpdate: bindActionCreators(SaveOrUpdate, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
